import { memo } from 'react';
import type { IIconProps } from '../interfaces';

const DeleteIcon = (props: IIconProps) => {
  const { width = 24, height = 24, color = 'currentColor' } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.2578 5.25488H3.75781" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.75781 9.75488V15.7549" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.2578 9.75488V15.7549" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M18.7578 5.25488V19.5049C18.7578 19.7038 18.6788 19.8946 18.5381 20.0352C18.3975 20.1759 18.2067 20.2549 18.0078 20.2549H6.00781C5.8089 20.2549 5.61813 20.1759 5.47748 20.0352C5.33683 19.8946 5.25781 19.7038 5.25781 19.5049V5.25488" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15.7578 5.25488V3.75488C15.7578 3.35706 15.5998 2.97553 15.3185 2.69422C15.0372 2.41292 14.6556 2.25488 14.2578 2.25488H9.75781C9.35999 2.25488 8.97846 2.41292 8.69715 2.69422C8.41585 2.97553 8.25781 3.35706 8.25781 3.75488V5.25488" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default memo(DeleteIcon);
